























import { Component, Vue } from 'vue-property-decorator';
import LbzButton from '../button/button.vue';

@Component({
  components: {
    LbzButton
  }
})
export default class LbzSnackbar extends Vue {
  private vactive = false;
  private vlabel = '';
  private vduration = 5000;
  private vclass = '';
  private valign = '';
  private vstacked = false;
  private vactionLabel = '';

  private vtimer: any = 0;

  private mounted(): void {
    this.vtimer = setTimeout((): void => {
      if (this.vactive) {
        this.vactive = false;
      }
    }, this.vduration);
  }

  private beforeDestroy(): void {
    clearTimeout(this.vtimer);
    this.vtimer = 0;
  }

  private fafterLeave(): void {
    clearTimeout(this.vtimer);
    this.vtimer = 0;
  }
}
